import React from 'react';
import { connect } from '../components/runtime-context';
import { getIsRTL } from '../store/basic-params/basic-params-selectors';

export type WithForDirection = {
  isRTL: boolean;
};

const forDirection = <P extends object>(
  ComponentLtr: React.ComponentType<P>,
  ComponentRtl: React.ComponentType<P>,
) => {
  const ForDirection = ({ isRTL, ...props }: WithForDirection & P) => {
    const Component = isRTL ? ComponentRtl : ComponentLtr;
    // isRTL is forwarded for the components that read it; the icons ignore it.
    return <Component {...({ isRTL, ...props } as unknown as P)} />;
  };

  const mapRuntimeToProps = (state: Parameters<typeof getIsRTL>[0]) => ({
    isRTL: getIsRTL(state),
  });

  return connect(mapRuntimeToProps)(
    ForDirection as React.ComponentType<WithForDirection>,
  ) as React.ComponentType<P>;
};

export default forDirection;
